<template>
    <div>
        <b-modal id="quoteDeleteModal" size="md" hide-footer centered modal-class="quote-delete-modal dep-modal-delete">
            <template #modal-header class="modal-header-wrapper p-0 ">
    </template>
    <b-container fluid class="p-0">
      <div class="modal_contentwrapper">
        <div class="icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <g fill="none">
              <path
                stroke="currentColor"
                stroke-width="1.5"
                d="M5.312 10.762C8.23 5.587 9.689 3 12 3s3.77 2.587 6.688 7.762l.364.644c2.425 4.3 3.638 6.45 2.542 8.022S17.786 21 12.364 21h-.728c-5.422 0-8.134 0-9.23-1.572s.117-3.722 2.542-8.022z"
              />
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-width="1.5"
                d="M12 8v5"
              />
              <circle cx="12" cy="16" r="1" fill="currentColor" />
            </g>
          </svg>
        </div>
        <div class="text-wrapper">
          <h5 class="mb-1">Delete Quote?</h5>
          <p class="mb-0">
            Are you sure you want to delete this Quote?
          </p>
        </div>
      </div>

      <div class="button-wrapper">
        <button
          type="button"
          class="btn cancel-btn btn-secondary"
          @click="closeModal"
        >
          Cancel
        </button>
        <b-button class="delete-btn" type="button" @click="deleteQuote">
          Delete
        </b-button>
      </div>
    </b-container>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "QuoteDeleteModal",
    methods: {
    closeModal() {
      this.$emit('closeDeleteModal');
      this.$bvModal.hide("quoteDeleteModal");
    },
    deleteQuote() {
      this.$emit('deleteQuote');
      this.$bvModal.hide("quoteDeleteModal");
    },
  },
};
</script>
<style scoped>
.button-wrapper {
  display: flex;
  justify-content: right;
  margin-top: 16px;
  gap: 14px;
  align-items: center;
}
.delete-btn,
.cancel-btn {
  padding: 10px 26px;
  width: fit-content;
  font-size: 14px;
  margin: 0;
}
.delete-btn {
  background: #dc3545;
  color: #fff;
  border: 0;
}
.delete-btn:focus,
.cancel-btn:focus {
  box-shadow: none;
  outline: none;
}
.delete-btn:hover {
  background: #c82333;
}

.quote-delete-modal .modal_contentwrapper {
  display: flex;
  gap: 16px;
}
.quote-delete-modal .modal_contentwrapper .icon-wrapper {
  background: #f7d9db;
  width: 46px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #dc3545;
  border-radius: 50%;
  flex-shrink: 0;
}
.quote-delete-modal .modal_contentwrapper .icon-wrapper svg {
  width: 24px;
  height: 24px;
}
.quote-delete-modal .modal_contentwrapper .text-wrapper h5 {
  font-weight: 600;
  color: #2c3f58;
  font-size: 18px;
}
.quote-delete-modal .modal_contentwrapper .text-wrapper p {
  color: #666;
}
</style>
<style>
.dep-modal-delete .modal-header {
  padding: 0 16px 8px 0;
}
</style>
